import React from 'react';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

const Dummy = () => {
  const [params] = useSearchParams();
  const text = params.get('text');

  return (
    <Box
      style={{
        width: '100%',
        height: '100%',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      <Typography variant="h2">Development Page</Typography>
      { text && (
        <Typography variant="body1">
          {text}
        </Typography>
      )}
    </Box>
  );
};

export default Dummy;
